<div class="header" *ngIf="isBrowser">
  <app-header></app-header>
</div><!-- END! header -->
<div class="page-render" [class.header-fixed]="headerFixed">
  <router-outlet></router-outlet>
</div><!-- END! page-render -->
<div class="footer">
  <app-footer></app-footer>
</div><!-- END! footer -->
